<template>
  <b-card
    align="left"
    class="booking-technician-card side-card"
    :class="{ 'has-positions': areTherePositions }"
    header-tag="header"
    no-body
  >
    <template #header>
      <b-row>
        <b-col>
          <h5>Rechazados</h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="position-wrapper" v-if="!areTherePositions && !areThereHardwarePositions">
            <div>
              <strong>¡Vaya!</strong>
            </div>
            Parece que no tienes nada en rechazados
          </div>
        </b-col>
      </b-row>
    </template>
    <b-card-body v-if="areTherePositions" class="position-list">
      <div v-for="position in positions" :key="position.getId">
        <BookingPositionSearchItem
          :position="position"
          @onClick="goToPosition"
          :notification="(showNotification(position.getId))"
        />
      </div>
    </b-card-body>
    <b-card-body v-if="areThereHardwarePositions" class="position-list">
      <div v-for="position in hardwarePositions" :key="position.getId">
        <HardwareBookingPositionSearchItem
          :position="position"
          @onClick="goToHardwarePosition"
          :notification="(showNotification(position.getId))"
        />
      </div>
    </b-card-body>
  </b-card>
</template>
<script>
import BookingPositionSearchItem from '@/components/BookingPosition/BookingPositionSearchItem'
import HardwareBookingPositionSearchItem from '@/components/HardwareBooking/HardwareBookingPositionSearchItem'

export default {
  name: 'BookingTechnicianRejectedCard',
  components: { HardwareBookingPositionSearchItem, BookingPositionSearchItem },
  data () {
    return {
      positions: [],
      hardwarePositions: [],
      baseUrl: process.env.VUE_APP_IMAGE_API_URL
    }
  },
  created () {
    this.loadData()
  },
  computed: {
    areTherePositions () {
      return this.positions.length > 0
    },
    areThereHardwarePositions () {
      return this.hardwarePositions.length > 0
    }
  },
  methods: {
    loadData () {
      this.$store.dispatch('getPositionRejected')
        .then((res) => {
          this.positions = res
        })
      this.$store.dispatch('hardwarePosition/getHardwarePositionsRejected')
        .then((res) => {
          this.hardwarePositions = res
        })
    },
    goToPosition (id) {
      this.$router.push({
        name: 'positions-rejected-position',
        params: {
          id: id
        }
      })
    },
    goToHardwarePosition (id) {
      this.$router.push({
        name: 'positions-rejected-hardware-position',
        params: {
          id: id
        }
      })
    },
    showNotification (id) {
      return this.$store.getters.technicianBookingNotifications.some((element) => {
        return element.bookingPosition.id === id
      })
    }
  }
}
</script>
<style lang="less">
  @import 'booking-techician.less';
  .position-contents {
    .business-name {
      cursor: pointer;
    }
  }
  .btn-outline {
    outline: none;
    img {
      outline: none;
    }
  }
  .position-wrapper {
    margin-top: 1.3rem;
    margin-bottom: 6.25rem;
  }
</style>
